module.exports = __webpack_public_path__ + "media/bootstrap-icons/stopwatch-de269bfd.svg";